import { render, staticRenderFns } from "./editOfficial.vue?vue&type=template&id=ff69c0ca&"
import script from "./editOfficial.vue?vue&type=script&lang=js&"
export * from "./editOfficial.vue?vue&type=script&lang=js&"
import style0 from "./editOfficial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports